import listActions from './listActions';

const langueActions = {};

langueActions.setLangue = (lang) => ({
  type: listActions.CHANGE_CURRENT_LANGUE,
  lang,
});

langueActions.editTemplates = (templates) => ({
  type: listActions.EDIT_TEMPLATES,
  templates,
});

langueActions.updateTempTemplates = (templates) => ({
  type: listActions.UPDATE_TEMP_TEMPLATES,
  templates,
});

langueActions.saveSuccessTemplates = () => ({type: listActions.EDIT_TEMPLATES_SUCCESS});

export default langueActions;




// WEBPACK FOOTER //
// ./src/store/actions/langueActions.js